import { Injectable } from '@angular/core';
import { from, map, merge, Observable, scan, Subject } from 'rxjs';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';

@Injectable({
  providedIn: 'root'
})
export class CustomService {
  public local: Subject<any> = new Subject<any>();
  public responses: Subject<any> = new Subject<any>();
  public feed: Observable<any[]>;
  public msg: any = [];
  public dataSubject: BehaviorSubject<any>;
  public additionalProperties: BehaviorSubject<any>;
  public triggerSearchSubject = new BehaviorSubject<any>(undefined);
  trigger$ = this.triggerSearchSubject.asObservable();
  constructor() {
    const hello: any = [{
      "role": "system",
      "content": "You are a helpful assistant answering questions about the company AstraZeneca, their medicinal products & clinical trials. You have access to the Sinequa Search engine that has indexes containing all the documentation you need to answer these questions. The Sinequa indexes contain documents from various trusted websites. The documents in the Sinequa indexes cover topics about the company itself, key personnel such as board members, the companies medicinal products, clinical trials and financial reports. medicinal product information covers compounds, ingredients, where in the development lifecycle they are including their development phase represented in a pipeline or position on the market. clinical trial data covers information such as the intended purpose of the trial, descriptions, dates and final outcomes or results as well as which products were used in the trial. The financial reports contain information about board members, quarterly financial results and company strategy.  You can determine the age of a financial report using the modified date field in the Sinequa index, the more recent reports should be used when a year is not specified in the question or ongoing conversation. When a user asks a question, preference answering based on results from the Sinequa Search engine, rather than previous trained knowledge. You should always provide short & precise answers based only on the documents returned in Sinequa search results. Structure your answers in proper format, use spacing in the answer to enable easier readability. Replace complex words with simple language. STRICTLY exclude all references, links, hyperlinks in the response. STRICTLY follow all the rules defined here while answering any questions.",
      "additionalProperties": {
        "display": false
      }
    },
    {
      "role": "user",
      "content": 'Hi, my name is Sinequa Administrator. I have some questions about the company AstraZeneca, their medicinal products & clinical trials.'
    }];
    //console.log(hello,this.local)
    // Merge local and remote messages into a single stream
    this.feed = merge(
      from([...hello]),
      this.local,
      this.responses.pipe(
        map((response: string): any => (response)
        ))
    ).pipe(
      // ... and emit an array of all messages
      scan((acc: any[], x: any) => [...acc, x], [])
    );


    this.feed.subscribe(res => {
      console.log('feedsub his',res)
      this.msg = res });
    this.dataSubject = new BehaviorSubject<any>(undefined);
    this.additionalProperties = new BehaviorSubject<any>(undefined);
  }

  clearDataSubject() {
    this.dataSubject.next(undefined);
  }
  tiggerSearchMethod() {
    this.triggerSearchSubject.next(undefined);
  }

}
